/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_NotificationService_DTOs_ResendEmailsDto } from '../models/Wealthlane_NotificationService_DTOs_ResendEmailsDto';
import type { Wealthlane_NotificationService_DTOs_ResendEmailsResponseDto } from '../models/Wealthlane_NotificationService_DTOs_ResendEmailsResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmailResendService {

    /**
     * @param requestBody 
     * @returns Wealthlane_NotificationService_DTOs_ResendEmailsResponseDto OK
     * @throws ApiError
     */
    public static postApiNotificationApiAppEmailResendResend(
requestBody?: Wealthlane_NotificationService_DTOs_ResendEmailsDto,
): CancelablePromise<Wealthlane_NotificationService_DTOs_ResendEmailsResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/api/app/email-resend/resend',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_NotificationService_DTOs_ResendEmailsResponseDto OK
     * @throws ApiError
     */
    public static postApiNotificationApiAppEmailResendResendEmails(
requestBody?: Wealthlane_NotificationService_DTOs_ResendEmailsDto,
): CancelablePromise<Wealthlane_NotificationService_DTOs_ResendEmailsResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/api/app/email-resend/resend-emails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
